const env = {
  greenbanker_base_url: process.env.REACT_APP_GREENBANKER_BASE_URL,
  greenbanker_admin_base_url: process.env.REACT_APP_GREENBANKER_ADMIN_BASE_URL,

  storeUser: (token, user) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
  },
  getUser: () => {
    return JSON.parse(localStorage.getItem("user"));
  },
  getToken: () => {
    let token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    return config;
  },
  logOut: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },

  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: false,
};
export default env;
